import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { getArticlesService } from '../../api/blogApi';
import { BlogState } from '../../types/features/blogSlice';
import { BlogResponse } from '../../types/api/blogApi';


export const getArticles = createAsyncThunk<BlogResponse>(
    'blog/getArticles',
    async () => {
        const response = await getArticlesService();
        return response.data; // Assumes response has a 'data' property
    }
);

const blogSlice = createSlice({
    name: 'blog',
    initialState: {
        loader: false,
        articles: [],
        status: false,
        msg: ''
    } as BlogState, // Type the initialState with AuthState
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getArticles.pending, (state) => {
                state.loader = true;
            })
            .addCase(getArticles.fulfilled, (state, action: PayloadAction<BlogResponse>) => {
                state.articles = action.payload.data;
                state.msg = action.payload.message;
                state.status = true;
                state.loader = false;
            })
            .addCase(getArticles.rejected, (state, action) => {
                state.loader = false;
                state.status = false;
                state.msg = action.error.message;
            })
    }
});

export default blogSlice.reducer;
